export class AddEditRacf {
    public racfUserMapId: number;
    public racfId: string;
    public active: boolean;
    public isEdit: boolean;
    public isDelete: boolean;
}
